module.exports = "<div class=\"sidebar\">\n  <div *ngFor=\"let category of navigation\">\n    <h2 *ngIf=\"category.name !== 'default'\">\n      {{ category.name | translate }}\n    </h2>\n    <ul class=\"nav nav-sidebar\">\n      <li *ngFor=\"let link of category.payload\" routerLinkActive=\"active\">\n        <a routerLink=\"/{{ category.path }}/{{ link.path }}\">{{\n          link.title | translate\n        }}</a>\n      </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/components/sidenav/sidenav.component.html
// module id = ../../../../../src/app/components/sidenav/sidenav.component.html
// module chunks = main